export default __webpack_public_path__ + "download-section.png";